var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36364 12H8.18182V10.1818C8.18182 9.92424 8.26909 9.70848 8.44364 9.53454C8.61818 9.3606 8.83394 9.27333 9.09091 9.27273H10.9091V11.0909L13.6364 8.36364L10.9091 5.63636V7.45454H9.09091C8.33333 7.45454 7.68939 7.7197 7.15909 8.25C6.62879 8.7803 6.36364 9.42424 6.36364 10.1818V12ZM2.72727 15.6364C2.22727 15.6364 1.79939 15.4585 1.44364 15.1027C1.08788 14.747 0.909697 14.3188 0.909091 13.8182V3.81818C0.909091 3.31818 1.08727 2.8903 1.44364 2.53455C1.8 2.17879 2.22788 2.00061 2.72727 2H17.2727C17.7727 2 18.2009 2.17818 18.5573 2.53455C18.9136 2.89091 19.0915 3.31879 19.0909 3.81818V13.8182C19.0909 14.3182 18.913 14.7464 18.5573 15.1027C18.2015 15.4591 17.7733 15.637 17.2727 15.6364H2.72727ZM0 18.3636V16.5455H20V18.3636H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreen);
export default __webpack_public_path__ + "static/media/share-screen.ddd1e702f3393277e784992683874c07.svg";
export { ForwardRef as ReactComponent };